export function removerHtml(valor: string): string {
  return valor.replace(/<[^>]*>/g, '');
}
